var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { CONSOLE_AUDIT_LOGS } from 'src/config';
import { useFlagEnabled } from 'src/flagging/hooks/useFlagEnabled';
import { v4 as uuid } from 'uuid';
import { useAxios } from './useAxios';
var ResourceType;
(function (ResourceType) {
    ResourceType["Note"] = "Note";
    ResourceType["MemberDemographics"] = "MemberDemographics";
    ResourceType["MemberDocuments"] = "MemberDocuments";
    ResourceType["Document"] = "Document";
    ResourceType["MemberAppointments"] = "MemberAppointments";
    ResourceType["Appointment"] = "Appointment";
    ResourceType["MemberMedications"] = "MemberMedications";
    ResourceType["MemberAssessments"] = "MemberAssessments";
    ResourceType["Schedule"] = "Schedule";
    ResourceType["UnscheduledInteraction"] = "UnscheduledInteraction";
})(ResourceType || (ResourceType = {}));
var ActionType;
(function (ActionType) {
    ActionType["View"] = "View";
})(ActionType || (ActionType = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes["EntryEvent"] = "Frontend-EntryEvent";
    EventTypes["ExitEvent"] = "Frontend-ExitEvent";
})(EventTypes || (EventTypes = {}));
var dispatchAuditLog = function (auditLog) {
    if (CONSOLE_AUDIT_LOGS)
        console.log(auditLog);
    var axios = useAxios();
    axios.request({
        method: 'POST',
        data: auditLog,
        url: '/api/v1/audit/',
        headers: { 'Content-Type': 'application/json' },
    });
};
var useAuditLog = function (data, enabled) {
    if (enabled === void 0) { enabled = true; }
    var effectEnabled = useFlagEnabled('ENABLE_AUDIT_LOGS') && enabled;
    useEffect(function () {
        if (!effectEnabled)
            return;
        var auditLog = __assign({ audit_type: EventTypes.EntryEvent, log_id: uuid(), access_start_time: new Date() }, data);
        dispatchAuditLog(auditLog);
        return function () {
            auditLog.access_end_time = new Date();
            auditLog.access_duration_seconds =
                (+auditLog.access_end_time - +auditLog.access_start_time) / 1000;
            auditLog.audit_type = EventTypes.ExitEvent;
            dispatchAuditLog(auditLog);
        };
    }, [effectEnabled]);
};
export { useAuditLog, ResourceType, ActionType };
